import { render, staticRenderFns } from "./good-price.vue?vue&type=template&id=4a0ff710&scoped=true"
import script from "./good-price.vue?vue&type=script&lang=js"
export * from "./good-price.vue?vue&type=script&lang=js"
import style0 from "./good-price.vue?vue&type=style&index=0&id=4a0ff710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ff710",
  null
  
)

export default component.exports